<template>
  <div class="container_box">
    <Tabs v-model="pageParams.status" :animated="false" class="tabs_styles" @on-click="search()">
      <TabPane v-for="item in statusList" :label="item.name" :name="item.value.toString()"></TabPane>
    </Tabs>
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002961')" prop="subsystemNames">
              <Select v-model="pageParams.subsystemNames" transfer multiple>
                <Option v-for="item in notificationObjectList" :key="item.value" :value="item.value">{{ item.value }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002962')" prop="createdBys">
              <Select v-model="pageParams.createdBys" transfer multiple filterable>
                <Option v-for="item in createdBysList" :key="item.userId" :value="item.userId">{{ item.userName }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002963')">
              <Date-picker
                style="width:100%"
                type="datetimerange"
                :transfer="true"
                @on-clear="resetDate"
                @on-change="getDateValue"
                :clearable="true"
                :options="dateOptions"
                format="yyyy-MM-dd HH:mm:ss"
                placement="bottom-end"
                :placeholder="$t('key1000360')"
                :value="timeValue">
              </Date-picker>
            </Form-item>
          </Col>
          <Col style="min-width: 200px;" push="1">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--创建公告-->
      <Button class="mr15" type="primary" v-if="getPermission('ymsNoticeInfo_insert')"
        @click="$refs['systemAnnouncement'].initSystemAnnouncementData('add')">
        {{ $t('key1002964') }}
      </Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        highlight-row
        border
        max-height="520"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="tableData">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--查看系统公告弹窗-->
    <viewAnnouncementModal ref="viewAnnouncement" @updateData="pageParamsStatus = true"></viewAnnouncementModal>
    <!--新增、编辑系统公告弹窗-->
    <systemAnnouncementModal ref="systemAnnouncement" @updateData="pageParamsStatus = true"></systemAnnouncementModal>
    <!--退回弹窗-->
    <returnedReasonModal ref="returnedReason" @returnedReasonBtn="returnedReasonBtn"></returnedReasonModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import systemAnnouncementModal from "@/views/yms/components/contentManage/systemAnnouncementModal.vue";
import viewAnnouncementModal from "@/components/common/viewAnnouncementModal.vue";
import returnedReasonModal from "@/components/common/returnedReasonModal.vue";
import {getAllUsersInfo, getUserNameByUserId} from "@/utils/common";

export default {
  name: "systemAnnouncement",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParamsStatus: false,
      pageParams: {
        createdBys: [],
        effectiveEndTime: null,
        effectiveStartTime: null,
        status: 'null', // 1草稿、2待修改、3待审核、4待发送、5已发送
        subsystemNames: [],
        pageNum: 1,
        pageSize: 15,
      },
      statusList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000110'), value: 'null'},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002942'), value: 1},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002943'), value: 2},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002944'), value: 3},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002945'), value: 4},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002946'), value: 5},
      ],
      notificationObjectList: [
        {value: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000015')},
        {value: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000014')}
      ],
      total: 0,
      createdBysList: [],
      timeValue: [],
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002947'),
          key: 'title',
          align: 'center',
          minWidth: 140
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002948'),
          key: 'status',
          align: 'center',
          minWidth: 140,
          render(h, params) {
            let text = '-';
            let status = params.row.status;
            let returnedReason = params.row.returnedReason || '';
            v.statusList.map((item) => {
              if (item.value === status) {
                text = item.name;
              }
            });
            return h('div', {class: 'flex align-items-center justify-content-center'}, [
              h('span', {style: {color: status === 2 ? '#D21010' : ''}}, text),
              status === 2 ? h('Tooltip', {
                props: {
                  transfer: true,
                  maxWidth: 300,
                  placement: 'top',
                  content: returnedReason
                },
                style: {
                  marginLeft: '5px'
                }
              },
              [
                h('Icon', {
                  props: {
                    type: 'md-help-circle',
                    size: 17
                  },
                  style: {
                    cursor: 'pointer',
                    color: '#D21010'
                  }
                })
              ]) : ''
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002949'),
          key: 'subsystemNames',
          align: 'center',
          minWidth: 140,
          render(h, params) {
            let text = '';
            let subsystemNames = params.row.subsystemNames;
            if (subsystemNames) {
              let arr = subsystemNames.split(',');
              text = arr.join('、');
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002950'),
          key: 'effectiveStartTime',
          align: 'left',
          width: 200,
          render(h, params) {
            let newTime = v.$uDate.getCurrentTime('fulltime');
            let effectiveStartTime = v.$uDate.dealTime(params.row.effectiveStartTime, 'fulltime');
            let talg = effectiveStartTime > newTime;
            return effectiveStartTime ? h('div', {class: 'flex align-items-center'}, [
              talg ? h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002951')) : '',
              h('span', params.row.effectiveStartTime ? effectiveStartTime : '-')
            ]) : '-';
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002158'),
          key: 'createdBy',
          minWidth: 140,
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.createdBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002952'),
          key: 'checkBy',
          minWidth: 140,
          align: 'center',
          render: (h, params) => {
            return h('div', getUserNameByUserId(params.row.checkBy, v.userInfoList));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          fixed: 'right',
          align: 'center',
          width: 120,
          render(h, params) {
            let status = params.row.status;// 1草稿、2待修改、3待审核、4待发送、5已发送
            let noticeInfoId = params.row.noticeInfoId;
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: true,
                    clickFn: () => {
                      v.$refs['viewAnnouncement'].getViewAnnouncementData(noticeInfoId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: [1, 2].includes(status) && v.getPermission('ymsNoticeInfo_update'),
                    clickFn: () => {
                      v.$refs['systemAnnouncement'].initSystemAnnouncementData('edit', noticeInfoId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002867'),
                    show: [3].includes(status) && v.getPermission('ymsNoticeInfo_checkNoticeInfo'),
                    clickFn: () => {
                      v.$Modal.confirm({
                        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002953'),
                        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002954'),
                        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000986'),
                        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
                        onOk: () => {
                          v.checkNoticeBtn(noticeInfoId, 1);
                        },
                        onCancel: () => {
                        }
                      });
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                    show: [1, 2].includes(status) && v.getPermission('ymsNoticeInfo_delete'),
                    color: '#FF0000',
                    clickFn: () => {
                      v.$Modal.confirm({
                        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002955'),
                        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002956'),
                        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000105'),
                        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
                        onOk: () => {
                          v.axios.delete(api.delete_ymsNoticeInfo + noticeInfoId, null, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
                            if (response.data.code === 0) {
                              v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002957'));
                              v.pageParamsStatus = true;
                            }
                          });
                        },
                        onCancel: () => {
                        }
                      });
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000640'),
                    show: [3].includes(status) && v.getPermission('ymsNoticeInfo_checkNoticeInfo'),
                    color: '#FF0000',
                    clickFn: () => {
                      v.noticeInfoId = noticeInfoId;
                      v.$refs['returnedReason'].returnedReasonModal = true;
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002958'),
                    color: '#FF0000',
                    show: [4].includes(status) && v.getPermission('ymsNoticeInfo_cancelSend'),
                    clickFn: () => {
                      v.$Modal.confirm({
                        title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002959'),
                        content: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002960'),
                        okText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002958'),
                        cancelText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000112'),
                        onOk: () => {
                          v.checkNoticeBtn(noticeInfoId, 3);
                        },
                        onCancel: () => {
                        }
                      });
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      noticeInfoId: null,
      userInfoList: {}
    };
  },
  created() {
    this.initFun();
  },
  methods: {
    // 初始化接口数据
    initFun() {
      this.createdBysList = [];
      (async () => {
        await getAllUsersInfo().then((data) => {
          this.userInfoList = data;
          if (data) {
            for (let key in data) {
              this.createdBysList.push({
                userId: data[key].userId,
                userName: data[key].userName
              });
            }
          }
        });
        await this.search();
      })();
    },
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.pageParamsStatus = true;
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.resetDate();
      v.timeValue = [];
      v.getList();
    },
    // 获取发送时间
    getDateValue(value) {
      let v = this;
      if (value.length === 0) {
        v.$Message.error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000356'));
        v.resetDate();
      } else {
        if (value[0] !== '') {
          let timeList = v.defaultTimePeriod(value);
          v.timeValue = v.defaultTimePeriod(value, false);
          v.pageParams.effectiveStartTime = v.$uDate.getUniversalTime(new Date(timeList[0]).getTime(), 'fulltime');
          v.pageParams.effectiveEndTime = v.$uDate.getUniversalTime(new Date(timeList[1]).getTime(), 'fulltime');
        }
      }
    },
    // 重置发送时间
    resetDate() {
      let v = this;
      v.pageParams.effectiveStartTime = null;
      v.pageParams.effectiveEndTime = null;
    },
    // 参数处理
    handleParameter() {
      let v = this;
      let params = Object.assign({}, v.pageParams);
      let keyList = ['status'];
      for (let key of keyList) {
        params[key] = v.pageParams[key] === 'null' ? null : v.pageParams[key];
      }
      return params;
    },
    // 列表查询的方法
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsNoticeInfo_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsNoticeInfo_query, v.handleParameter()).then(response => {
          v.tableLoading = false;
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              let list = data.list || [];
              v.tableData = list;
              v.total = data.total;
            }
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 审核/退回/取消发送
    checkNoticeBtn(noticeInfoId, operationType, returnedReason) {
      let v = this;
      let query = {
        noticeInfoId: noticeInfoId,
        operationType: operationType, // 操作 1审核通过、2审核退回 3取消发送
        returnedReason: returnedReason || '',
      };
      let obj = {
        1: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000486'),
        2: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000487'),
        3: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000488'),
      };
      let url = operationType === 3 ? api.put_ymsNoticeInfo_cancelSend : api.put_ymsNoticeInfo_checkNoticeInfo;
      v.axios.put(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          v.$Message.success(obj[operationType]);
          v.$refs['returnedReason'].returnedReasonModal = false;
          v.pageParamsStatus = true;
        }
      });
    },
    // 退回
    returnedReasonBtn(val) {
      this.checkNoticeBtn(this.noticeInfoId, 2, val);
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    systemAnnouncementModal,
    viewAnnouncementModal,
    returnedReasonModal
  }
};
</script>

<style lang="less" scoped>

</style>
